<div class="row">
 <div class="col">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink='/'>Covid-19 Tracker</a>
    <a class="navbar-link" routerLink='/'>Home <span class="sr-only">(current)</span></a>
    <a class="navbar-link" routerLink='countries'> &nbsp; Countries</a>
    <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> -->
    <!-- </button> -->
      <!-- <ol class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" routerLink='/'>Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink='countries'>Countries</a>
        </li>
      </ol>-->
  </nav> 

  </div>





</div>